import { useEffect, useState } from 'react';

export default function useOneTrustCookie(cookieName) {
  const [isConsented, setIsConsented] = useState(false);
  useEffect(() => {
    const checkConsent = () => {
      const hasConsented =
        window &&
        !!window.OnetrustActiveGroups &&
        window.OnetrustActiveGroups?.toLowerCase()?.includes(
          cookieName.toLowerCase()
        );
      setIsConsented(hasConsented);
    };

    checkConsent();

    const onConsentUpdate = (event) => {
      const hasConsented = event?.detail?.includes(cookieName);
      setIsConsented(hasConsented);
    };

    window.addEventListener('OneTrustGroupsUpdated', onConsentUpdate);
    return () => {
      window.removeEventListener('OneTrustGroupsUpdated', onConsentUpdate);
    };
  }, []);

  return {
    isConsented,
  };
}
